import { render } from "./taohaowangHome.vue?vue&type=template&id=15199c91&scoped=true"
import script from "./taohaowangHome.vue?vue&type=script&lang=js"
export * from "./taohaowangHome.vue?vue&type=script&lang=js"

import "./taohaowangHome.vue?vue&type=style&index=0&id=15199c91&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15199c91"]])

export default __exports__